import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import type { TriggerDistribution } from "@/lib/analytics/types";

interface TriggerEventsChartProps {
  rows: TriggerDistribution[];
}

export function TriggerEventsChart({ rows }: TriggerEventsChartProps) {
  const data = rows.slice(0, 10);
  return (
    <Card>
      <CardHeader>
        <CardTitle>Trigger events</CardTitle>
        <CardDescription>Top events that launched runs</CardDescription>
      </CardHeader>
      <CardContent className="h-64">
        {data.length === 0 ? (
          <div className="h-full flex items-center justify-center text-sm text-muted-foreground">
            No runs found.
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
              <XAxis type="number" stroke="var(--muted-foreground)" fontSize={12} />
              <YAxis
                type="category"
                dataKey="event"
                stroke="var(--muted-foreground)"
                fontSize={12}
                width={110}
              />
              <Tooltip
                contentStyle={{
                  background: "var(--popover)",
                  border: "1px solid var(--border)",
                  borderRadius: "0.375rem",
                  fontSize: "0.75rem",
                }}
              />
              <Bar dataKey="count" fill="var(--chart-1)" radius={[0, 2, 2, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
